import styles from './Receipt.module.scss';

export const ReceiptAlert = (props) => <div className={styles.alert} {...props} />;
